import React from "react";
import { Link, useLocation } from "react-router-dom";

const ROUTE_LABELS: Record<string, string> = {
  "content-management": "Administración de contenidos",
  "manage-banners": "Banner principal",
  "create-banners": "Banner principal",
  "manage-info-cards": "Secciones intermedias",
  "create-info-cards": "Secciones intermedias",
  "manage-info-apply": "Quiero aplicar",
  "create-info-apply": "Quiero aplicar",
  "manage-info-talent": "Bloque de texto",
  "create-info-talent": "Bloque de texto",
  "manage-list-items": "Lista de ítems",
  "create-list-items": "Lista de ítems",
  "manage-about-us": "Quiénes somos",
  "create-about-us": "Quiénes somos",
  "manage-staff": "Equipo",
  "create-staff": "Equipo",
  "manage-staff-team": "Integrantes del equipo",
  "create-staff-team": "Integrantes del equipo",
  "manage-our-work": "Qué hacemos",
  "create-our-work": "Qué hacemos",
  "manage-portofolio": "Portafolio",
  "create-portofolio": "Portafolio",
  "manage-enterprises": "Empresas",
  "create-enterprises": "Empresas",
  "manage-founders": "Fundadores",
  "create-founders": "Fundadores",
  "manage-how-to-apply": "Cómo aplicar",
  "create-how-to-apply": "Cómo aplicar",
  "manage-card-apply": "Tarjetas de aplicación",
  "create-card-apply": "Tarjetas de aplicación",
  "manage-faqs": "Preguntas frecuentes",
  "create-faqs": "Preguntas frecuentes",
};

const ROUTE_LINKS: Record<string, string> = {
  "content-management": "/app/content-management/manage-banners",
};

const AppBreadcrumb: React.FC = () => {
  const location = useLocation();

  const parts = location.pathname
    .split("/")
    .filter(Boolean)
    .filter((part) => part !== "app")
    .filter((part) => !/^[0-9a-fA-F-]{20,}$/.test(part));

  const items = [
    { label: "Inicio", path: "/app/dashboard" },
    ...parts.map((part) => ({
      label: ROUTE_LABELS[part] || part,
      path: ROUTE_LINKS[part] || location.pathname,
    })),
  ];

  return (
    <nav
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
        margin: "4px 0 24px",
        padding: "10px 14px",
        background: "#ffffff",
        border: "1px solid #eef0f5",
        borderRadius: 12,
        width: "fit-content",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 && <span style={{ color: "#9ca3af" }}>›</span>}

            {isLast ? (
              <span
                style={{
                  color: "#001740",
                  fontWeight: 700,
                  background: "#F0F7FF",
                  padding: "4px 10px",
                  borderRadius: 999,
                }}
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                style={{
                  color: "#253B7F",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default AppBreadcrumb;